/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2025 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import { servGetFundingsFunded } from '@/services/zetonium'
import { format } from 'date-fns'
import { formLeosToZetons } from '@/utils/pds'
import _ from 'lodash'

export const getFundings = async ({ userId, getAccessToken }) => {
  // Get fundings
  const currentDateMilliseconds = Date.now()
  // 1 year in seconds 31536000
  const timeAmountInSec = 31536000
  const fromTimestampInSec = Math.round(currentDateMilliseconds / 1000) - timeAmountInSec
  // Search from 1 year back from current date
  /* fundingsResponse is an object like this:
      {
        fundedInfo: [
          { userId, funderId, termSheetTemplate, terms: { totalLeos, leosPerTx, ttl, lastBlockSec, totalNoLimits }, isActualTerms, initial }
        ]
      }
   */
  const fundingsResponse = await servGetFundingsFunded({
    searchParams: { userId, fromTimestampInSec },
    getAccessToken
  })
  if (!_.isEmpty(fundingsResponse.fundedInfo)) {
    // fundedInfo contains an array with every funding the user has
    const userFundings = fundingsResponse.fundedInfo.map(funding => {
      const balance = parseInt(funding.terms.totalLeos)
      const limit = parseInt(funding.terms.leosPerTx)
      const ttl = parseInt(funding.terms.ttl)
      return {
        balance,
        limit,
        ttl
      }
    })

    // Get balance, limit, expiration date
    // Balance should be one number that totals up all the funding granted to current user
    const balance = _.reduce(userFundings, function (sum, funding) {
      return sum + funding.balance
    }, 0)
    // Limit should be the largest value of the limits in the array
    const limitsList = _.orderBy(userFundings, ['limit'], ['desc'])
    const limit = _.isEmpty(limitsList) ? 0 : limitsList[0].limit
    //
    const expirationDatesList = _.orderBy(userFundings, ['ttl'], ['desc'])
    const expirationDate = new Date(expirationDatesList[0].ttl * 1000) // TODO: Fix, this in in UTC */

    const creditDetails = [
      {
        label: 'Balance:',
        text: formLeosToZetons(balance)
      },
      {
        label: 'Limit:',
        text: formLeosToZetons(limit)
      },
      {
        label: 'Expiration Date:',
        text: format(expirationDate, 'MMM dd, yyyy HH:mm:ss')
      }
    ]
    return creditDetails
  }
}
